import { render } from "./Distributor-edit.vue?vue&type=template&id=4d014252"
import script from "./Distributor-edit.vue?vue&type=script&lang=js"
export * from "./Distributor-edit.vue?vue&type=script&lang=js"

import "./Distributor-edit.vue?vue&type=style&index=0&id=4d014252&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__